import { Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { LoadingComponent, LoadingProps } from "@shared/components/loading/loading.component";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private dialog = inject(MatDialog);

  present(data: LoadingProps) {
    this.dialog.open(LoadingComponent, {
      height: "100%",
      width: "100%",
      maxWidth: "100%",
      disableClose: true,
      autoFocus: false,
      enterAnimationDuration: 0,
      data,
    });
  }

  dismissAll() {
    this.dialog.closeAll();
  }
}
